// DataGolf alpha-3 country code → flagcdn.com slug. The provider
// returns an alpha-3 ISO code (mostly) on each field row; flagcdn.com
// wants alpha-2 (or one of its supported regional subdivisions like
// `gb-eng` for England). Unknown codes return null so the caller can
// render a no-flag placeholder instead of a broken image.
//
// DataGolf quirks vs. strict ISO-3166-1:
//   - ENG/SCO/NIR/WAL — UK constituent countries, expanded to flagcdn's
//     regional slugs (`gb-eng`, etc.) so a UK player shows their actual
//     flag, not the Union Jack.
//   - GER → de (DG uses GER, not DEU)
//   - RSA → za (DG uses RSA, not ZAF)
//   - DEN → dk, SUI → ch, NED → nl
//   - TPE → tw  (Chinese Taipei / Taiwan)
//   - CHI → cl  (Chile — DG uses CHI for Chile, not China; CHN is China)
//   - ZIM → zw

const ALPHA3_TO_FLAG_SLUG = {
  ARG: 'ar', AUS: 'au', AUT: 'at', BEL: 'be', CAN: 'ca', CHI: 'cl',
  CHN: 'cn', COL: 'co', CZE: 'cz', DEN: 'dk', ENG: 'gb-eng', ESP: 'es',
  FIN: 'fi', FRA: 'fr', GER: 'de', IND: 'in', IRL: 'ie', ITA: 'it',
  JPN: 'jp', KOR: 'kr', MEX: 'mx', NED: 'nl', NIR: 'gb-nir', NOR: 'no',
  NZL: 'nz', PHI: 'ph', POL: 'pl', POR: 'pt', RSA: 'za', SCO: 'gb-sct',
  SUI: 'ch', SWE: 'se', THA: 'th', TPE: 'tw', UAE: 'ae', USA: 'us',
  VEN: 've', WAL: 'gb-wls', ZIM: 'zw',
}

export function countryToFlagSlug(alpha3) {
  if (!alpha3) return null
  return ALPHA3_TO_FLAG_SLUG[String(alpha3).toUpperCase()] || null
}

// flagcdn.com — free CDN that serves country flags as PNG and SVG.
// Width-suffixed PNGs (`/w40/us.png`) are the rendering sweet spot for
// a chip-sized flag — 24px display width at 2x DPR.
export function flagUrl(alpha3, widthPx = 40) {
  const slug = countryToFlagSlug(alpha3)
  if (!slug) return null
  return `https://flagcdn.com/w${widthPx}/${slug}.png`
}

// Initials helper — "Keith Mitchell" → "KM". Handles single names,
// "Last, First" DG format ("Aberg, Ludvig" → "LA"), and Jr./III suffixes.
export function playerInitials(fullName) {
  if (!fullName) return '?'
  let s = String(fullName).trim()
  // "Last, First" → "First Last" so initials pick up first then last.
  if (s.includes(',')) {
    const [last, first] = s.split(',').map(t => t.trim())
    s = `${first} ${last}`
  }
  const parts = s.split(/\s+/).filter(p => !/^(jr\.?|sr\.?|ii|iii|iv)$/i.test(p))
  if (parts.length === 0) return '?'
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase()
}
